export const ENVIRONMENTS = {
    STAGE: 'stage',
    TEST: 'test',
    TRIAL: 'trial',
    PROD: 'prod',
    DEV: 'dev'
};

export const NON_POWERTRAIN_ORGANIZATION_TAB_OPTIONS = ['userManagement', 'assetManagemnt'];
